<template>
  <div>
    <h2>Slet onboarding steps</h2>
    <div class="flex">
      <button @click="deleteSetupWidgetOpen">Slet Setup widget åben?</button>
      <button @click="deleteKlass">Slet klasse</button>
      <button @click="deleteUser">Slet Bruger</button>
      <button @click="deleteRoom">Slet Lokale</button>
      <button @click="deleteMerge">Slet Merge</button>
      <button @click="deleteVacation">Slet ferie</button>
      <button @click="deleteScheduling">Slet skemalægning</button>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      deleteSetupWidgetOpen () {
        this.$store.dispatch('deleteUserSetting', 'setupWidgetOpen')
      },
      deleteKlass () {
        this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_klass')
      },
      deleteUser () {
        this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_users')
      },
      deleteRoom () {
        this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_rooms')
      },
      deleteMerge () {
        this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_merge')
      },
      deleteScheduling () {
        this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_scheduling')
      },
      deleteVacation () {
        this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_vacation')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DeleteUserSettings.vue?587ee857